export default {
  GET_ORGS: 'GET_ORGS',
  SAVE_ORG: 'SAVE_ORG',
  DELETE_ORG: 'DELETE_ORG',
  GET_ROOT_ORGS: 'GET_ROOT_ORGS',
  GET_ORG_TREE: 'GET_ORG_TREE'
}
